import { onError } from '@apollo/client/link/error';
import handleUnknownApolloErrors from '../../utils/error/handleUnknownApolloErrors';

export default onError((apolloError) =>
  handleUnknownApolloErrors(apolloError, 'Apollo'),
);
